import { api } from "./client";

export type ReviewResolution = "APPROVED" | "REJECTED" | "NEEDS_REVIEW";

export type ReviewQueueRow = {
  work_id: string;
  title: string | null;
  type: string | null;
  // CreatorDetail is keyed by CREATOR id (/creators/:id), not the profile id.
  creator_id: string | null;
  profile_name: string | null;
  reviewer: string | null;
  resolution: ReviewResolution | null;
  notes: string | null;
  created_at: string | null;
};

export type ReviewQueueListResponse = {
  items: ReviewQueueRow[];
  total: number;
};

export type ReviewersResponse = {
  reviewers: string[];
  /** The logged-in support user, so the UI can float them to the top. */
  me: string | null;
};

export type ReviewQueueUpdate = {
  reviewer?: string | null;
  notes?: string | null;
  resolution?: ReviewResolution;
};

export type ReviewQueueUpdateResponse = {
  ok: boolean;
  work_id: string;
  /** True when the resolution drove a real certification status change. */
  resolution_applied: boolean;
};

export const ReviewQueueApi = {
  list() {
    return api.get<ReviewQueueListResponse>("/review-queue").then((r) => r.data);
  },
  reviewers() {
    return api.get<ReviewersResponse>("/review-queue/reviewers").then((r) => r.data);
  },
  update(workId: string, body: ReviewQueueUpdate) {
    return api
      .patch<ReviewQueueUpdateResponse>(`/review-queue/${workId}`, body)
      .then((r) => r.data);
  },
};
